const MOCK_ASSET_ID_PATTERN = /^(asset_mock|mock)/;

export function shouldFetchRenderedInstagramCards(asset) {
  return Boolean(
    asset?.id &&
      asset.platform === "instagram" &&
      !MOCK_ASSET_ID_PATTERN.test(asset.id),
  );
}
